/* eslint-disable import/no-cycle */
import * as API from './api';

const ContactModel = { ...API };

export default ContactModel;
